import React, { useState, useRef } from "react";
import axios from "axios";
import { useUser } from "../context/useUser";

const url = process.env.REACT_APP_BACKEND_CONNECTION

export default function AdminImportUsers() {
  const { user } = useUser();
  const [file, setFile] = useState(null);
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(false);
  const fileInputRef = useRef(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!file) {
      setStatus("Please select a CSV file first.");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);

    setLoading(true);
    setStatus("");

    try {
      const response = await axios.post(
        `${url}/admin/import-users`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${user.token}`,
          },
        }
      );
      setStatus(response.data.message);
    if (response.data.errors && response.data.errors.length > 0) {
        const errorList = response.data.errors
          .map((e) => `${e.user || "Unknown"} — ${e.error}`)
          .join("\n");
        setStatus(`Import completed with some errors:\n${errorList}`);
      }
    } catch (error) {
      console.error("Import error:", error);
      setStatus(
        error.response?.data?.error || "Something went wrong during import."
      );
    } finally {
      setLoading(false);

      setFile(null);
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
    }
  };


return (
  <div className="default-container">
    <div className="default-box">
      <h2 className="default-title">
        <i className="fas fa-users-cog" /> Lisää Käyttäjä
      </h2>

      <form onSubmit={handleSubmit} className="admin-form">
        <label className="admin-label">
          <i className="fas fa-file-csv" /> Valitse CSV Tiedosto:
        </label>
        <input
          ref={fileInputRef}
          id="csvFileInput"
          type="file"
          accept=".csv"
          onChange={(e) => setFile(e.target.files[0])}
          className="admin-input"
        />

        <button className="default-button" type="submit" disabled={loading}>
          {loading ? (
            <>
              <i className="fas fa-spinner fa-spin" /> Ladataan...
            </>
          ) : (
            <>
              <i className="fas fa-upload" /> Lataa
            </>
          )}
        </button>
      </form>

      {status && (
        <p
          className={`status-text ${
            status.toLowerCase().includes("error") ||
            status.toLowerCase().includes("wrong") ||
            status.toLowerCase().includes("please")
              ? "error"
              : "success"}`}>
          <i
            className={
              status.toLowerCase().includes("error") ||
              status.toLowerCase().includes("wrong") ||
              status.toLowerCase().includes("please")
                ? "fas fa-exclamation-circle"
                : "fas fa-check-circle"
            } />{" "}
          {status}
        </p>
      )}
    </div>
  </div>
)}